(() => {
  if (customElements.get('praetor-kit')) return;
  class PraetorKit extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.q = (s) => this.querySelector(s);
      this.qa = (s) => [...this.querySelectorAll(s)];
      this.variants = JSON.parse(this.q('[data-variants]').textContent);
      this.optionValues = ['', '', 'Estándar'];
      this.money = (c) => new Intl.NumberFormat('es-MX', { style: 'currency', currency: this.dataset.currency || 'MXN', maximumFractionDigits: 0 }).format(c / 100) + ' MXN';
      this.abort = new AbortController();
      const listen = (el, name, fn) => el.addEventListener(name, fn, { signal: this.abort.signal });
      this.q('[data-fallback-select]').disabled = true;
      this.q('.pr-fallback').hidden = true;
      this.q('.pr-enhanced').hidden = false;
      this.q('[data-add]').hidden = false;
      this.qa('[data-option]').forEach(input => listen(input, 'change', () => {
        this.optionValues[Number(input.dataset.option)] = input.value;
        this.q('[data-success]').hidden = true;
        this.q('[data-error]').hidden = true;
        this.update();
      }));
      this.qa('[data-jump]').forEach(b => listen(b, 'click', () => this.jump()));
      listen(this.q('[data-sticky-action]'), 'click', (e) => {
        if (this.variant?.available && !this.busy) this.add(e); else this.jump();
      });
      listen(this.q('[data-add]'), 'click', e => this.add(e));
      this.qa('[data-guide]').forEach(b => listen(b, 'click', () => { this.guide(Number(b.dataset.guide)); this.q('[data-guide-dialog]').showModal(); }));
      this.qa('[data-guide-tab]').forEach(b => listen(b, 'click', () => this.guide(Number(b.dataset.guideTab))));
      this.qa('dialog').forEach(d => {
        listen(d.querySelector('[data-close]'), 'click', () => d.close());
        listen(d, 'click', e => { if (e.target === d) { const r=d.getBoundingClientRect(); if (e.clientX<r.left || e.clientX>r.right || e.clientY<r.top || e.clientY>r.bottom) d.close(); } });
      });
      this.gallery = this.q('[data-gallery]');
      this.qa('[data-thumb]').forEach(b => listen(b, 'click', () => {
        this.gallery.scrollTo({ left: Number(b.dataset.thumb) * this.gallery.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }));
      listen(this.gallery, 'scroll', () => {
        const index = Math.round(this.gallery.scrollLeft / this.gallery.clientWidth);
        this.qa('[data-thumb]').forEach((b,i) => b.setAttribute('aria-current', String(i === index)));
        this.q('[data-gallery-count]').textContent = `${index+1} / ${this.qa('[data-slide]').length}`;
      });
      this.qa('[data-zoom]').forEach(b => listen(b, 'click', () => {
        const src=this.qa('[data-slide]')[Number(b.dataset.zoom)].querySelector('img');
        const target=this.q('[data-zoom-image]'); target.src=src.src; target.alt=src.alt;
        this.q('[data-image-dialog]').showModal();
      }));
      this.observer = new IntersectionObserver(entries => {
        this.q('[data-sticky]').hidden = entries[0].isIntersecting;
      }, { threshold: 0.2 });
      this.observer.observe(this.q('[data-add]'));
      const requestedId = new URL(location.href).searchParams.get('variant');
      const requested = this.variants.find(v => String(v.id) === requestedId);
      if (requested) {
        this.optionValues = [...requested.options];
        this.qa('[data-option]').forEach(input => input.checked = input.value === this.optionValues[Number(input.dataset.option)]);
      }
      this.update();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.ready=false; }
    guide(index) {
      this.qa('[data-guide-panel]').forEach((p,i) => p.hidden = i !== index);
      this.qa('[data-guide-tab]').forEach((b,i) => b.setAttribute('aria-pressed', String(i === index)));
    }
    jump() {
      this.q('.pr-buy').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'start' });
      const index=this.optionValues.findIndex(v=>!v);
      const input=this.q(`[data-option="${index < 0 ? 0 : index}"]`);
      input?.focus({preventScroll:true});
    }
    update() {
      this.variant=this.variants.find(v=>v.options.every((o,i)=>o===this.optionValues[i]));
      const base=this.variant?.price ?? Number(this.dataset.basePrice);
      const shipping=this.optionValues[2] === 'Exprés' ? 11900 : 0;
      const total=this.money(base + shipping);
      this.q('[data-total]').textContent=total;
      this.q('[data-sticky-total]').textContent=total;
      this.q('[data-breakdown]').textContent=`Kit ${this.money(base)} + ${shipping ? 'envío exprés $119' : 'envío gratis'}`;
      const selected=this.optionValues.slice(0,2).every(Boolean);
      this.q('[data-selection]').textContent=selected ? `Hoodie ${this.optionValues[0]} · Playera ${this.optionValues[1]} · ${this.optionValues[2]}` : 'Elige las tallas de tus dos prendas.';
      const input=this.q('[data-variant-id]'); input.value=this.variant?.id||''; input.disabled=!this.variant;
      this.q('[data-add]').disabled=!this.variant?.available || this.busy;
      this.q('[data-add]').innerHTML=selected ? (this.variant?.available ? 'Agregar mi kit <span aria-hidden="true">↗</span>' : 'Combinación no disponible') : 'Selecciona tus tallas <span aria-hidden="true">↑</span>';
      this.q('[data-sticky-action]').textContent=this.variant?.available?'Agregar mi kit ↗':'Elegir tallas ↗';
      if (this.variant) { const u=new URL(location.href); u.searchParams.set('variant',this.variant.id); history.replaceState(null,'',u); }
    }
    async add(event) {
      event.preventDefault();
      event.stopPropagation();
      if (!this.variant?.available || this.busy) return;
      this.busy=true;
      this.q('[data-add]').disabled=true;
      this.q('[data-sticky-action]').disabled=true;
      this.q('[data-error]').hidden=true;
      const status=this.q('[data-status]'); status.textContent='Agregando tu kit…'; status.hidden=false;
      try {
        const root=this.dataset.root || '/';
        const response=await fetch(`${root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:this.variant.id,quantity:1}]} )});
        const data=await response.json();
        if (!response.ok) throw new Error(typeof data.description==='string'?data.description:'No se pudo agregar el kit. Inténtalo de nuevo.');
        status.textContent='Kit agregado. Revisa tu carrito.';
        const vitalsDrawer=document.querySelector('aside.Vtl-CartDrawer');
        this.q('[data-success]').hidden=Boolean(vitalsDrawer);
        if (!vitalsDrawer) {
          this.q('[data-success]').querySelector('a').focus({preventScroll:true});
          this.q('[data-success]').scrollIntoView({behavior:'smooth',block:'nearest'});
        }
        try { const cart=await fetch(`${root}cart.js`,{headers:{Accept:'application/json'}}).then(r=>r.json()); this.q('[data-cart-count]').textContent=cart.item_count; } catch (_) { /* Cart addition succeeded even if the counter refresh failed. */ }
      } catch(error) {
        status.hidden=true;
        this.q('[data-error]').textContent=error.message || 'Hubo un problema de conexión. Revisa tu carrito antes de intentarlo otra vez.';
        this.q('[data-error]').hidden=false;
      } finally { this.busy=false; this.q('[data-sticky-action]').disabled=false; this.update(); }
    }
  }
  customElements.define('praetor-kit',PraetorKit);
})();

(() => {
  const deliveryRange = (minDays, maxDays, now = new Date()) => {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Mexico_City', year: 'numeric', month: 'numeric', day: 'numeric'
    }).formatToParts(now);
    const part = type => Number(parts.find(item => item.type === type).value);
    const base = new Date(Date.UTC(part('year'), part('month') - 1, part('day')));
    const advance = days => {
      const date = new Date(base);
      date.setUTCDate(date.getUTCDate() + days);
      return date;
    };
    const start = advance(minDays);
    const end = advance(maxDays);
    const options = { day: 'numeric', month: 'long', timeZone: 'UTC' };
    if (end.getUTCFullYear() !== base.getUTCFullYear()) options.year = 'numeric';
    const formatter = new Intl.DateTimeFormat('es-MX', options);
    const sameMonth = start.getUTCMonth() === end.getUTCMonth()
      && start.getUTCFullYear() === end.getUTCFullYear();
    return `entre el ${sameMonth ? start.getUTCDate() : formatter.format(start)} y el ${formatter.format(end)}`;
  };
  document.querySelectorAll('praetor-kit').forEach(root => {
    const labelFor = value => root.querySelector(`[data-option="2"][value="${value}"]`)?.closest('label')?.querySelector('small');
    const standard = labelFor('Estándar');
    const express = labelFor('Exprés');
    const faq = [...root.querySelectorAll('.pr-faq details')].find(detail =>
      detail.querySelector('summary')?.textContent.trim() === '¿Cuándo llega y cómo elijo el envío?'
    )?.querySelector('p');
    const chargeNote = root.querySelector('.pr-charge-note');
    const expressInput = root.querySelector('[data-option="2"][value="Exprés"]');
    const render = () => {
      const standardRange = deliveryRange(10, 13);
      const expressRange = deliveryRange(3, 5);
      if (standard) standard.textContent = `Recibe ${standardRange}`;
      if (express) express.textContent = `Despacho en 3–5 días naturales. Lo enviamos ${expressRange}.`;
      if (faq) faq.textContent = `Con envío estándar gratis, recibe ${standardRange}; la estimación incluye preparación y traslado. Con exprés por $119 adicionales, despachamos tu kit en 3–5 días naturales: lo enviamos ${expressRange}. Estas fechas corresponden a la salida del pedido; la entrega dependerá del traslado y tu destino. Recibirás seguimiento cuando salga.`;
      if (chargeNote) chargeNote.textContent = expressInput?.checked
        ? `Exprés: despacho estimado ${expressRange}. La llegada depende del traslado y tu destino. Los $119 se cobran como envío al finalizar la compra.`
        : 'Si eliges exprés, despachamos en 3–5 días naturales; después sigue el traslado. Los $119 se cobran como envío al finalizar la compra.';
    };
    render();
    root.querySelectorAll('[data-option="2"]').forEach(input => input.addEventListener('change', render));
    const timer = window.setInterval(() => {
      if (root.isConnected) render(); else window.clearInterval(timer);
    }, 60000);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden && root.isConnected) render();
    });
    window.addEventListener('pageshow', () => {
      if (root.isConnected) render();
    });
  });
})();
